<template>
  <div>
    <div class="fullPageContent closed">
      <DashboardHeader
      v-bind:title="pageTitle">
      </DashboardHeader>
      <NewsEvents></NewsEvents>
    </div>
  </div>
</template>
<script>
import DashboardHeader from "./partials/DashboardHeader.vue";
import NewsEvents from "./NewsEvents/NewsEvents.vue";


export default {
  data() {
    return {
      pageTitle:this.$t("dashboard.help_and_support"),
      notCompleted: true,
    };
  },
  computed: {},
  components: {
    DashboardHeader,
    NewsEvents,
  },
  mounted() {
      this.$store.dispatch("app/loader", false);
  },
  methods: {
  },
};
</script>



<style>
</style>